// src/assets/data/cursos/cripto-blockchain/en/modulo-1-en.js
import banner from "../../../courses/module-2/img1.png";

const modulo1 = {
  courseId: "cripto-blockchain",
  id: "modulo-1",
  title: "🧩 MODULE 1: What is Web3 and why does it matter?",
  estimatedDuration: "1 hour",
  format: "Reading + knowledge check activity",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 Module objective",
      content: [
        "Understand what Web3 is, how the Internet has evolved from its previous versions, and why this new digital stage can change the way we interact with technology, money, social media, and our own data.",
      ],
    },
    {
      id: "evolucion",
      navLabel: "Web evolution",
      title: "🔍 The evolution of the Internet: from Web1 to Web3",
      content: [
        {
          type: "table",
          headers: [
            "Version",
            "What could you do?",
            "Who had the power?",
            "Examples",
          ],
          rows: [
            [
              "Web 1.0 (1990–2004)",
              "Only read information",
              "Companies or universities",
              "Static websites, news portals",
            ],
            [
              "Web 2.0 (2004–2020)",
              "Read, publish, interact, share",
              "Large platforms (Google, Meta, TikTok)",
              "YouTube, Instagram, Uber, Amazon",
            ],
            [
              "Web 3.0 (2020–today)",
              "Read, publish, own content and data",
              "Users themselves (thanks to blockchain)",
              "dApps, NFTs, DAOs, metaverse",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "🧠 Summary: Web1 was a digital library. Web2 is a social network dominated by companies. Web3 is a new Internet where you are in control.",
        },
        {
          type: "paragraph",
          text: "🔎 Note: People also talk about Web 4.0 and Web 5.0 (AI, smart homes, emotional recognition…), but today we are focusing on Web3.",
        },
      ],
    },
    {
      id: "definicion",
      navLabel: "Definition",
      title: "🔍 What is Web3?",
      content: [
        {
          type: "paragraph",
          text: "Web3 is a new way of using the Internet based on blockchain technology, where users can control their data, digital identity, and money without depending on large corporations or banks.",
        },
        {
          type: "table",
          headers: ["Term", "What does it mean?", "Real example"],
          rows: [
            [
              "Blockchain",
              "A public, secure, and immutable database",
              "Anyone can see transactions, but no one can modify them",
            ],
            [
              "Decentralization",
              "Power is distributed; there is no single owner",
              "You do not need permission or a bank to send funds",
            ],
            [
              "Token",
              "A digital asset with value on the blockchain",
              "Cryptocurrency, NFT, digital tickets",
            ],
            [
              "Wallet",
              "An app that stores your crypto and digital identity",
              "MetaMask, Trust Wallet",
            ],
            [
              "dApp",
              "An application without a central server",
              "Web3 games, NFT marketplaces",
            ],
            [
              "DAO",
              "An organization without a boss, governed by voting",
              "Communities that decide how to manage their treasury together",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "💡 Why does it matter? You can earn tokens by participating, control your identity and money, and learn key skills for the future.",
        },
      ],
    },
    {
      id: "casos-reales",
      navLabel: "Real cases",
      title: "🏢 Real-world Web3 use cases",
      content: [
        {
          type: "table",
          headers: ["Company / Project", "How does it use Web3?"],
          rows: [
            [
              "Reddit",
              "Unique digital avatars (collectibles) that users can use or sell",
            ],
            [
              "Nike and Adidas",
              "Digital sneakers with blockchain certificates (collectible items)",
            ],
            [
              "Starbucks",
              "Web3 rewards program: users earn special digital items",
            ],
            [
              "Brave Browser",
              "Pays you with tokens for voluntarily watching ads",
            ],
            [
              "Axie Infinity",
              "A play-to-earn game where you earn crypto by playing",
            ],
          ],
        },
      ],
    },
    {
      id: "videos",
      navLabel: "Explainer videos",
      title: "📺 Explainer videos",
      content: [
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=TQGOfo2tWF8",
          text: "🎥 Web3: The Future? What It Is and How It Works (Bybit, 17 min)",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=-ulNaSStAIw",
          text: "🎥 Web3 Bootcamp for Beginners (Chainlink Español, 20 min)",
        },
        {
          type: "link",
          href: "https://www.youtube.com/watch?v=86NtlVPhFkc",
          text: "🎥 What is Web3? (Cripto en Minutos, 5 min)",
        },
      ],
    },
    {
      id: "lecturas",
      navLabel: "Readings",
      title: "📚 Complementary readings",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/what-are-web3-wallets",
          text: "Binance Academy – What are Web3 Wallets?",
        },
        {
          type: "link",
          href: "https://cryptoconexion.com/que-es-la-web-3",
          text: "CryptoConexión – What is Web3?",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Activity",
      title: "✅ Knowledge check activity",
      content: [
        "Answer these questions in your notebook",
        {
          type: "list",
          items: [
            "What is the main difference between Web2 and Web3?",
            "What does “decentralization” mean and why is it important?",
            "What is a wallet used for?",
            "Mention one company that uses Web3 and what you learned from its example.",
            "Would you like to try a Web3 app? Which one and why?",
          ],
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Quote of the day",
      title: "🧠 Quote of the day",
      content: ["“In Web2, you were the product. In Web3, you are the owner.”"],
    },
  ],
};

export default modulo1;
